import React, { useEffect, useState } from "react";
import api from "@/lib/api";

// Fetches a protected image via XHR (sends auth header/cookie) and shows as blob.
export function FileImage({ path, alt = "", className = "", fallback = null, ...rest }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoked = null;
    let active = true;
    if (!path) { setSrc(null); return; }
    setFailed(false);
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        const url = URL.createObjectURL(res.data);
        revoked = url;
        setSrc(url);
      })
      .catch(() => active && setFailed(true));
    return () => { active = false; if (revoked) URL.revokeObjectURL(revoked); };
  }, [path]);

  if (!path || failed) return fallback;
  if (!src) return <div className={`${className} animate-pulse bg-[rgba(212,175,55,0.06)]`} {...rest} />;
  return <img src={src} alt={alt} className={className} {...rest} />;
}
